<template>
	<div>
		<div class="sre-banner hidden-md-and-down" :style="{backgroundImage:'url('+dataimgs[0].src1+')'}">
			<el-row>
				<el-col :lg="4" :xl="4">
					<div class="hidden-md-and-down">&nbsp;</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
					<div class="center">
						<div class="banner-overlay1">
							<h1>{{dataimgs[0].title}}</h1>
							<p v-for="c in dataimgs[0].content" :key='c'>{{c}}</p>
							<div class="try-btn-area">
								<a :href="dataimgs[0].url" class="hidden-md-and-down">
									<div class="btn">{{dataimgs[0].btn}}</div>
								</a>
								<a :href="dataimgs[0].url" class="hidden-lg-and-up">
									<div class="btn">{{dataimgs[0].btn}}</div>
								</a>
							</div>
						</div>
						<div class="intro">
						</div>
					</div>
				</el-col>
				<el-col :lg="4" :xl="4">
					<div class="hidden-md-and-down">&nbsp;</div>
				</el-col>
			</el-row>
		</div>
		<div class="sre-banner hidden-lg-and-up" :style="{backgroundImage:'url('+dataimgs[0].src2+')'}">
			<el-row>
				<el-col :lg="4" :xl="4">
					<div class="hidden-md-and-down">&nbsp;</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
					<div class="center">
						<div class="banner-overlay1">
							<h1>{{dataimgs[0].title}}</h1>
							<p v-for="c in dataimgs[0].content" :key='c'>{{c}}</p>
							<div class="try-btn-area">
								<a :href="dataimgs[0].url" class="hidden-md-and-down">
									<div class="btn">{{dataimgs[0].btn}}</div>
								</a>
								<a :href="dataimgs[0].url" class="hidden-lg-and-up">
									<div class="btn">{{dataimgs[0].btn}}</div>
								</a>
							</div>
						</div>
						<!-- <div class="intro">
						</div> -->
					</div>
				</el-col>
				<el-col :lg="4" :xl="4">
					<div class="hidden-md-and-down">&nbsp;</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'SreBanner',
		props: ['dataimgs'],
		data() {
			return {
				dialogVisible: false
			}
		}
	}
</script>

<style>
	.sre-banner {
		margin-top: 60px;
		height: 678px;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-color: #043F6A;
	}

	.sre-banner .center {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}

	.sre-banner .el-dialog__header {
		padding: 20px 20px 0px;
	}

	.sre-banner .el-dialog__title {
		line-height: 22px;
		font-size: 16px;
		color: #303133;
		font-family: "microsoft yahei";
		text-align: left;
		display: block;
	}

	.sre-banner .banner-overlay1 {
		/* width: 570px; */
		padding: 180px 30px 0;
		color: #FFFFFF;
		text-align: left;
	}

	.sre-banner .banner-overlay1 .title {
		-webkit-transform: translateY(0px) !important;
		transform: translateY(0px) !important;
		opacity: 1 !important;
		font-size: 30px;
		font-family: MFYueHei_Noncommercial-Light;
		color: rgba(255, 255, 255, 1);
		/* line-height: 63px; */
		font-weight: lighter;
	}

	.sre-banner .banner-overlay1 h1 {
		color: #FFFFFF;
		font-size: 30px;
		transform: translateY(0px);
		line-height: 64px;
		transition: all 0.6s;
		margin-bottom: 15px;
		width: 100%;
	}

	.sre-banner .banner-overlay1 p {
		color: #FFFFFF;
		font-size: 16px;
		transform: translateY(0px);
		line-height: 30px;
		transition: all 0.6s;
		width: 100%;
		opacity: .59;
	}

	.sre-banner .banner-overlay1 .try-btn-area {
		/* color: #FFFFFF; */
		/* width: initial; */
		/* text-align: left; */
		/* font-size: 48px; */
		/* line-height: 48px; */
		margin-top: 107px;
	}

	.sre-banner .intro {
		width: 570px;
		/* height: 320px; */
		padding: 100px 15px 0;
	}

	.sre-banner .intro .content {
		width: 400px;
		height: 90px;
		background: rgba(81, 100, 128, .4);
		padding: 28px 24px 28px 30px;
	}

	.sre-banner .intro .content h4 {
		font-size: 18px;
		font-family: MicrosoftYaHei;
		color: rgba(255, 255, 255, 1);
		margin: initial;
	}

	.sre-banner .intro .content p {
		margin-top: 17px;
		font-size: 12px;
		font-family: MicrosoftYaHei;
		color: rgba(255, 255, 255, 1);
		width: 100%;
	}

	.sre-banner .try-btn-area a {
		display: block;
		width: 168px;
	}

	.sre-banner .try-btn-area .btn {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 162px;
		height: 48px;
		background-color: #00F4FF;
		border-radius: 2px;
		color: #253549 !important;
		font-family: simhei;
		font-size: 18px;
	}

	@media(max-width:992px) {
		.sre-banner {
			margin-top: 0;
			height: 188px;
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}

		.sre-banner .center {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: space-around;
		}

		.sre-banner .banner-overlay1 {
			width: 260px;
			padding: 40px 0px 0 20px;
			margin-left: -100px;
			color: #FFFFFF;
			text-align: left;
		}

		.sre-banner .banner-overlay1 .title {
			-webkit-transform: translateY(0px) !important;
			transform: translateY(0px) !important;
			opacity: 1 !important;
			font-size: 0.18rem;
			font-family: MFYueHei_Noncommercial-Light;
			color: rgba(255, 255, 255, 1);
			/* line-height: 63px; */
			font-weight: lighter;
		}

		.sre-banner .banner-overlay1 h1 {
			color: #FFFFFF;
			font-size: 0.14rem;
			transform: translateY(0px);
			line-height: 24px;
			transition: all 0.6s;
			margin-bottom: 5px;
		}

		.sre-banner .banner-overlay1 p {
			color: rgba(255, 255, 255, .5);
			font-size: 0.12rem;
			transform: translateY(0px);
			line-height: 14px;
			transition: all 0.6s;
			width: 180px;
		}

		.sre-banner .banner-overlay1 .try-btn-area {
			color: #FFFFFF;
			width: initial;
			text-align: left;
			font-size: 48px;
			line-height: 48px;
			margin-top: 0.1rem;
		}

		.sre-banner .banner-overlay1 .try-btn-area .el-button {
			type: small;
			margin-left: 0;
		}

		.sre-banner .try-btn-area .btn {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 0.81rem;
			height: 0.24rem;
			background-color: #00F4FF;
			border-radius: 2px;
			color: #253549 !important;
			font-family: simhei;
			font-size: 0.12rem;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/SreBanner.vue